import 'modules/sidebar';

window.clearSearchCookies  = function() {
    createTransientCookie('searchBrandFilterByRevolveR1', '');
    createTransientCookie('searchDepartmentFilterByRevolveR1', '');
    createTransientCookie('searchColourFilterByRevolveR1', '');
    createTransientCookie('searchCategoryFilterByRevolveR1', '');
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/header/index.js